























































export default {
    name: 'BaseStepByStep',
    components: {},
    props: {},
    data() {
        return {};
    },
    methods: {},
};
